import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

const getState = ({swing}: IStore) => swing;

export const getSwings = createSelector(getState, (state) => state.swings);
